export default __webpack_public_path__ + "static/media/pinWhite.33b3012e.svg";